import React from "react";
import { Select, AutoComplete, Input } from "antd";
import "./style.scss";
import { userLookupRequest } from "../../ducks/data";
import { addSubmitForm } from "../../ducks/app";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { makeGetUserLookup } from "../../selectors/data";

const Option = Select.Option;
const _ = require("lodash");
const makeMapStateToProps = () => {
  const mapStateToProps = (state, props) => {
    const getUserLookup = makeGetUserLookup();
    return {
      isLoading: state.data.loadingUserLookup,
      data: state.data.userLookup ? getUserLookup(state, props) : []
    };
  };

  return mapStateToProps;
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      userLookupRequest,
      addSubmitForm
    },
    dispatch
  );

@connect(
  makeMapStateToProps,
  mapDispatchToProps
)
class EmailSearchInput extends React.Component {
  state = {};
  handleSearch = value => {
    if (value.length % 3 === 0) {
      this.props.userLookupRequest(value);
    }
    this.props.addSubmitForm({
      id: undefined,
      type: "users",
      attributes: { email: value }
    });
  };

  handleChange = value => {
    this.setState({ value });
  };

  handleSelect = (value, option) => {
    let user = this.props.data.find(u => u.id === value);
    delete user.attributes["role"];
    delete user.attributes["userRoles"];
    this.props.addSubmitForm(user);
  };
  render() {
    const options =
      this.props.data &&
      this.props.data.map(d => {
        let label = `${d.attributes.email} (${d.attributes.username})`;
        return <Option key={d.id}>{label}</Option>;
      });
    return (
      <AutoComplete
        size="large"
        style={{ width: "100%" }}
        dataSource={options}
        onSelect={this.handleSelect}
        onSearch={this.handleSearch}
        defaultValue={this.props.defaultValue}
      >
        <Input />
      </AutoComplete>
    );
  }
}

export default EmailSearchInput;

/*
      <Select
        showSearch
        defaultValue={this.state.value}
        value={this.state.value}
        placeholder={this.props.placeholder}
        style={this.props.style}
        defaultActiveFirstOption={false}
        autoClearSearchValue={false}
        showArrow={true}
        filterOption={false}
        onSearch={this.handleSearch}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
        notFoundContent={null}
        allowClear={true}
      >
        {options}
      </Select>*/



// WEBPACK FOOTER //
// ./src/components/Profile/EmailSearchInput.js